import { Grid } from '@material-ui/core';
import moment from 'moment';
import React, { useState } from 'react';

import { CampaignActiveActive } from '~/src/dash/api/campaign/campaign';
import {
  CampaignFrequencyActiveInactive,
  EAllowStatus,
  TargetBoolTypeAll,
  TargetingCCPAAll,
  TargetingCoppaAll,
  ETargetingDeviceIDTypes,
  TargetingGDPRAll,
  TargetingLogicOR,
  TargetingRequestedPodDurationNoMax,
  TargetingRequestedPodDurationNoMin,
} from '~/src/dash/api/console-api';
import { getAdserverOrder, IAdserverOrder } from '~/src/dash/api/order';
import { EBool } from '~/src/dash/api/types/bool';
import { IStore } from '~/src/dash/reducers/store';
import { parseLocation } from '~/src/dash/router/routes';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { ELogicalOperator } from '~/src/dash/utils/options';
import { CampaignFormView } from '~/src/dash/views/campaign/campaign-form-view';

interface IProps extends IWithStylesProps, IReduxActionProps, ISessionStateProps, IHistoryProps {}

export const CampaignNewView = decorate(
  {
    redux: (state: IStore) => {
      return {
        session: state.session,
      };
    },
  },
  function ({ session, location }: IProps) {
    const [order, setOrder] = useState<IAdserverOrder>();
    const newName = 'lineItem-' + new Date().getTime();
    const loc = parseLocation(location.pathname);
    const isPremion = session.publisher.ID === '788';
    const orderID = loc.order || '0';
    getAdserverOrder(orderID, session.publisher.ID, true).then((parentOrder: IAdserverOrder) => {
      if (!order) {
        setOrder(parentOrder);
      }
    });
    return (
      <Grid container direction='column'>
        <CampaignFormView
          campaign={{
            ID: '',
            UUID: '',
            CreatedAt: '',
            UpdatedAt: '',
            DeletedAt: '',

            PublisherID: session.publisher.ID,
            StartDate: '',
            EndDate: '',
            Name: newName,
            Active: CampaignActiveActive,
            Alias: '',
            FrequencyTTL: '86400',
            FrequencyLimit: '1',
            FrequencyActive: CampaignFrequencyActiveInactive,
            FrequencyCaps: [],
            IABCategory: '',
            QuantityType: '1',
            Quantity: '1000000',
            CPM: '10.00',
            GrossCPM: '0.00',
            Adomain: '',
            AdserverCampaignTrackers: [],
            AdserverCreatives: [],
            TargetedCountries: isPremion ? 'us' : '',
            TargetingAppBundleIDIsAllowed: EAllowStatus.ALLOW,
            TargetingAppBundleSitePagesLogic: ELogicalOperator.AND,
            TargetingContentChannel: '',
            TargetingContentChannelIsAllowed: EAllowStatus.ALLOW,
            TargetingContentDistributor: '',
            TargetingContentDistributorIsAllowed: EAllowStatus.ALLOW,
            TargetingContentGenre: '',
            TargetingContentGenreIsAllowed: EAllowStatus.ALLOW,
            TargetingContentID: '',
            TargetingContentIDIsAllowed: EAllowStatus.ALLOW,
            TargetingContentNetwork: '',
            TargetingContentNetworkIsAllowed: EAllowStatus.ALLOW,
            TargetingContentProducer: '',
            TargetingContentProducerIsAllowed: EAllowStatus.ALLOW,
            TargetingContentRating: '',
            TargetingContentRatingIsAllowed: EAllowStatus.ALLOW,
            TargetingContentSeries: '',
            TargetingContentSeriesIsAllowed: EAllowStatus.ALLOW,
            TargetingContentTitle: '',
            TargetingContentTitleIsAllowed: EAllowStatus.ALLOW,
            TargetingContentLanguage: '',
            TargetingContentLanguageIsAllowed: EAllowStatus.ALLOW,
            TargetingCountryGroupIDs: '',
            TargetingCountryGroupIDsIsAllowed: EAllowStatus.ALLOW,
            TargetingDealID: '',
            TargetingDealIDIsAllowed: EAllowStatus.ALLOW,
            TargetingFWSectionIDs: '',
            TargetingFWSectionIDsIsAllowed: EAllowStatus.ALLOW,
            TargetingSitePages: '',
            TargetingSitePagesIsAllowed: EAllowStatus.ALLOW,
            LocalTargetingAllowed: '',
            LocalTargetingAllowedLogic: TargetingLogicOR,
            LocalTargetingDisallowed: '',
            LocalTargetingDisallowedLogic: TargetingLogicOR,
            TargetingAudienceSegmentIDIsAllowed: EAllowStatus.ALLOW,
            TargetingDevicesIsAllowed: EAllowStatus.ALLOW,
            TargetingDeviceTypes: '',
            TargetingDeviceTypesIsAllowed: EAllowStatus.ALLOW,
            TargetingDeviceSubTypes: '',
            TargetingDeviceSubTypesIsAllowed: EAllowStatus.ALLOW,
            TargetingCoppa: TargetingCoppaAll,
            TargetingLimitedAdTracking: TargetBoolTypeAll,
            AdserverOrderID: loc.order,
            SiteAdserverCampaignAssociations: [],
            ChannelGroupAdserverCampaignAssociations: [],
            ChannelListAdserverCampaignAssociations: [],
            SiteWeightsActive: EBool.EBool_FALSE,
            DisableLowPacing: EBool.EBool_FALSE,
            EnableOverDelivery: EBool.EBool_FALSE,
            ServeRightAway: EBool.EBool_FALSE,
            SkipEnabled: EBool.EBool_FALSE,
            SkipOffset: 0,
            ContextualSegmentIDS: [] as number[],
            CustomTargeting: '',
            CustomTargetingInclusion: EAllowStatus.ALLOW,
            TargetingCustom4: '',
            TargetingCustom4Inclusion: EAllowStatus.ALLOW,
            TargetingCustom5: '',
            TargetingCustom5Inclusion: EAllowStatus.ALLOW,
            TargetingCustom6: '',
            TargetingCustom6Inclusion: EAllowStatus.ALLOW,
            TargetingCustom7: '',
            TargetingCustom7Inclusion: EAllowStatus.ALLOW,
            TargetingCustom8: '',
            TargetingCustom8Inclusion: EAllowStatus.ALLOW,
            TargetingCustom9: '',
            TargetingCustom9Inclusion: EAllowStatus.ALLOW,
            TargetingCustom10: '',
            TargetingCustom10Inclusion: EAllowStatus.ALLOW,
            TargetingCustom11: '',
            TargetingCustom11Inclusion: EAllowStatus.ALLOW,
            TargetingCustom12: '',
            TargetingCustom12Inclusion: EAllowStatus.ALLOW,
            TargetingCustom13: '',
            TargetingCustom13Inclusion: EAllowStatus.ALLOW,
            TargetingCustom14: '',
            TargetingCustom14Inclusion: EAllowStatus.ALLOW,
            TargetingCustom15: '',
            TargetingCustom15Inclusion: EAllowStatus.ALLOW,
            TargetingCustom16: '',
            TargetingCustom16Inclusion: EAllowStatus.ALLOW,
            TargetingCustom17: '',
            TargetingCustom17Inclusion: EAllowStatus.ALLOW,
            TargetingCustom18: '',
            TargetingCustom18Inclusion: EAllowStatus.ALLOW,
            FlightDateCheckpoints: [],
            FlightDateCheckpointsEnabled: EBool.EBool_FALSE,
            FlightDateCheckpointsRolloverEnabled: EBool.EBool_TRUE,
            GuaranteedDeliveryEnabled: EBool.EBool_FALSE,
            TargetingCCPA: TargetingCCPAAll,
            TargetingGDPR: TargetingGDPRAll,
            TargetingGDPRConsent: TargetBoolTypeAll,
            TargetingDeviceIDType: ETargetingDeviceIDTypes.ALL,
            TargetingRequestedPodDurationMin: TargetingRequestedPodDurationNoMin,
            TargetingRequestedPodDurationMax: TargetingRequestedPodDurationNoMax,
            TargetingGvinParamExists: EBool.EBool_FALSE,
            SamplingPercentageDisabledUntil: moment.utc(new Date()).format('YYYY-MM-DDTHH:mm:ssZ'),
          }}
          order={order}
        />
      </Grid>
    );
  },
);
